import { lazy, Suspense, useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArViewer from "./components/ARViewer";
import Loader from "./components/Loader";
import NotFound from "./components/NotFound";
import SmartObjectViewer from "./pages/smartobjectviewer";
import CurrentContext from "./utils/CurrentContext";
import { getProductsData } from "./utils/dbApis.js";
import { allFinishes } from "./utils/materials.js";
import ConfiguratorViewer from "./components/ConfiguratorViewer/ConfiguratorViewerV2.js";
import { AnimatedLoader } from "./components/Loader/AnimatedLoader.js";
import ARViewerCustom from "./components/Configurator/ArViewer/ArViewerCustom.js";
import ArViewerWrapperCustom from "./components/Configurator/ArViewer/ArViewerWrapperCustom.js";
import ProductPage from "./screens/ProductPage.jsx";
import { CONFIGURATOR_UUID } from "./helpers/configData.js";

const Home = lazy(() => import("./pages/home.js")); 
const ARViewerWrapper = lazy(() => import("./components/ARViewerWrapper.js"));

function App() {
  const [current, setCurrent] = useState("");
  const [viewerData, setViewerData] = useState({});
  const [orbitCamera, setOrbitCamera] = useState(true);
  const [autoRotate, setAutoRotate] = useState(false);
  const [displayMeasure, setIsMeasure] = useState(false);

  // State variables for different finishes
  const [upholsteryFinish, setUpholsteryFinish] = useState([]);
  const [paintColorFinish, setPaintColorFinish] = useState([]);
  const [legFinish, setLegFinish] = useState([]);
  const [legFinishPaintColor, setLegFinishPaintColor] = useState([]); // need to rename this
  const [cushionFinish, setCushionFinish] = useState([]);
  const [woodTopFinish, setWoodTopFinish] = useState([]);
  const [chairFrameFinish, setChairFrameFinish] = useState([]);
  const [retreatFabricFinish, setRetreatFabricFinish] = useState([]);
  const [retreatLegFinish, setRetreatLegFinish] = useState([]);
  const [turnedLegFinish, setTurnedLegFinish] = useState([]);
  const [metalLegFinish, setMetalLegFinish] = useState([]);
  const [headboardFabricFinish, setHeadboardFabricFinish] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [productVariants, setProductVariants] = useState([]);
  const [variantName, setVariantName] = useState(null);

  const [uuid, setUuid] = useState();

  const [defaultFinish, setDefaultFinish] = useState({});

  // State variable for the currently selected finishes
  const [currentFinishes, setCurrentFinishes] = useState({
    upholsteryFinish: "",
    legFinish: "",
    paintColorFinish: "",
    legPaintColorFinish: "",
    cushionFinish: "",
    woodTopFinish: "",
    chairFrameFinish: "",
    retreatFabricFinish: "",
    retreatLegFinish: "",
    turnedLegFinish: "",
    metalLegFinish: "",
    headboardFabricFinish: "",
  });
  const [currentMaterialFinish, setCurrentMaterialFinish] = useState({});

  const [iframeMessage, setIframeMessage] = useState("");

  // For Ar Viewer
  const [loading, setLoading] = useState(false);
  const [isARReady, setIsARReady] = useState(false);
  const [ARModelSrc, setARModelSrc] = useState(null);
  const [ARUnicode, setARUnicode] = useState(null);
  const [isAR, setIsAR] = useState(false);
  const [aoIntensity, setAOIntensity] = useState(null)
  const [arSrc, setArSrc] = useState(null);

  const loadProductsData = async () => {
    const data = await getProductsData();
    data && setProductsData(data);
  };

  useEffect(() => {
    // Handler function for the message event
    const handleMessage = (event) => {
      // console.log("check", event.data.type);
      if (event.data !== iframeMessage) {
        // console.log(event.data);
        // console.log("finishToSet", finishToSet);
        switch (event.data.type) {
          case "Variation":
            setVariantName(event.data.value);
            break;
          case "Movement":
            setVariantName(event.data.value);
            break;
          case "Side":
            setVariantName(event.data.value);
            break;
          case "Hardware Style":
            setVariantName(event.data.value);
            break;
          case "Nails":
            setVariantName(event.data.value);
          break;
          case "Upholstery":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                upholsteryFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Leg Finish":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                legFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Leg Finish + Paint Color":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                legPaintColorFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Paint Color":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                paintColorFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Cushion":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                cushionFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Wood Top":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                woodTopFinish: event.data.value,
              }),
            }));
            break;
          case "Headboard Fabric":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                headboardFabricFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Metal Legs":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                metalLegFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Retreat Fabrics":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                retreatFabricFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Retreat Leg Finish":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                retreatLegFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Turned Leg Finish":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                turnedLegFinish: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Chair Frame":
            console.log("chairFrameFinish", event.data.value);
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                chairFrameFinish: event.data.value,
              }),
            }));
            break;
          case "Bamboo Bed Paint":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                otherFabric: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Welt":
            console.log("welt", event.data.value);
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                otherFabric: finishToSet(event.data.value),
              }),
            }));
            break;
          case "Lattice Collection Paint Colors":
            setCurrentFinishes((prev) => ({
              ...prev,
              ...(event.data.value && {
                otherFabric: finishToSet(event.data.value),
              }),
            }));
            break;
          default:
            break;
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [iframeMessage]);

  function finishToSet(id) {
    return allFinishes.find((item) => item.id === parseInt(id))?.value;
  }

  useEffect(() => {
    console.log("currentFinishes", currentFinishes);
  }, [currentFinishes]);

  useEffect(() => {
    const routeUuid = window.location.pathname.split("/")[1];
    const isConfiguratorRoute = CONFIGURATOR_UUID.includes(routeUuid);
    if (!isConfiguratorRoute) {
      loadProductsData();
    }
  }, []);

  useEffect(() => {
    if (uuid && productsData) {
      setDefaultFinish(
        productVariants.length > 1
          ? productVariants.find((product) => product.variant === variantName)
              .default.finish
          : productsData.find((product) => product.id === parseInt(uuid))
              .default.finish
      );
    }
    setIsMeasure(false);
  }, [uuid]);

  useEffect(() => {
    if (uuid && productsData) {
      const matchedProducts = productsData.filter(
        (product) => product.uuid === parseInt(uuid)
      );
      setProductVariants(matchedProducts);
      // console.log(matchedProducts, "matchedProducts");
      const defaultVariantProduct = matchedProducts.find(
        (product) => product.defaultVariant === true
      );
      defaultVariantProduct && setVariantName(defaultVariantProduct.variant);
      defaultVariantProduct && setAOIntensity(defaultVariantProduct.aoIntensity);
    }
  }, [uuid]);

  useEffect(() => {
    const updateFinishes = () => {
      const updatedFinishes = {};

      for (const key in defaultFinish) {
        if (defaultFinish[key].default) {
          updatedFinishes[key] = defaultFinish[key].default;
        }
      }

      setCurrentFinishes((prevFinishes) => ({
        ...prevFinishes,
        ...updatedFinishes,
      }));
    };

    // Call updateFinishes whenever you need to update
    updateFinishes();
  }, [defaultFinish]);

  useEffect(() => {
    console.log("headboardFabricFinish", headboardFabricFinish);
  }, [headboardFabricFinish]);

  const propObject = {
    current: current,
    autoRotate,
    setAutoRotate,
    orbitCamera,
    setOrbitCamera,
    upholsteryFinish,
    setUpholsteryFinish,
    paintColorFinish,
    setPaintColorFinish,
    legFinish,
    setLegFinish,
    legFinishPaintColor,
    setLegFinishPaintColor,
    cushionFinish,
    setCushionFinish,
    woodTopFinish,
    setWoodTopFinish,
    chairFrameFinish,
    setChairFrameFinish,
    retreatFabricFinish,
    setRetreatFabricFinish,
    retreatLegFinish,
    setRetreatLegFinish,
    turnedLegFinish,
    setTurnedLegFinish,
    metalLegFinish,
    setMetalLegFinish,
    headboardFabricFinish,
    setHeadboardFabricFinish,
    currentFinishes,
    setCurrentFinishes,
    uuid,
    setUuid,
    defaultFinish,
    setDefaultFinish,
    displayMeasure,
    setIsMeasure,
    productsData,
    productVariants,
    setProductVariants,
    variantName,
    setVariantName,
    currentMaterialFinish,
    setCurrentMaterialFinish,
    //for Ar Viewer
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    arSrc,
    setArSrc,
    //for ao
    aoIntensity,
    setAOIntensity,
  };

  // const configuratorUUIDs = ['13','29','21','5','53','9','12','10','8','24'];

  return (
    <Suspense fallback={
      // <Loader loading={true} position="fixed" />
      <AnimatedLoader
        zIndex={1000}
        position="fixed"
        top={0}
        backDrop={"rgba(255, 255, 255, 1"}
      />
    }>
      <CurrentContext.Provider value={propObject}>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/:uuid"
              // element={
              //   productsData.length > 0 ? (
              //     configuratorUUIDs.includes(uuid) ? (
              //       <ConfiguratorViewer />
              //     ) : (
              //       <SmartObjectViewer
              //         viewerData={viewerData}
              //         setViewerData={setViewerData}
              //       />
              //     )
              //   ) : null
              // }
              element={
                <ProductPage
                  productsData={productsData}
                  viewerData={viewerData}
                  setViewerData={setViewerData}
                  loadProductsData={loadProductsData}
                />
              }
            />
            {/* <Route
              path="/:uuid/preview/:token"
              element={<ArViewer viewerData={viewerData} />}
            /> */}
            <Route
              path="/p-ar/preview/:token"
              element={<ARViewerCustom />}
            />
            <Route path={"*"} element={<NotFound />} />
          </Routes>
        </Router>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          limit={5}
        />
        {/* <Loader loading={loading} transparentBg={true} /> */}
        {loading && <AnimatedLoader
          zIndex={1000}
          position="fixed"
          top={0}
          // backDrop={"rgba(255, 255, 255, 1"}
          backDrop={"transparent"}
        />}

        {/* {CONFIGURATOR_UUID.includes(uuid) ? (
          <ArViewerWrapperCustom/>
        ): <ARViewerWrapper />} */}
        <ArViewerWrapperCustom/>

      </CurrentContext.Provider>
    </Suspense>
  );
}

export default App;
